import Vue from 'vue'
import { PRIVATE_LAYOUT, PUBLIC_REDUCED_LAYOUT } from '../constants/layouts'

export default {
  routerViewTemplate: '<router-view></router-view>',
  buildRoutes: function (path, children, layout = null) {
    const _this = this
    return {
      path: path,
      component: layout || {
        template: _this.routerViewTemplate
      },
      children: children
    }
  },
  routeHasReducedLayout (route) {
    return (route || Vue.prototype.$route).meta.layout === PUBLIC_REDUCED_LAYOUT
  },
	completeRoutesMeta (routes, roles, layout = PRIVATE_LAYOUT, inheritedMeta = {}) {
		return routes.map(route => {
			route.meta = route.meta || {}
			route.meta.layout = route.meta.layout || layout

			// Inherit meta attributes if they exist
			route.meta = this.buildInheritedMeta(route.meta, inheritedMeta)
			
			if (typeof roles === 'string') {
				roles = [roles]
			}
			route.meta.roles = route.meta.roles || []
			// Check if any of the roles are missing in route.meta.roles
			roles.forEach(role => {
				if (!route.meta.roles.includes(role)) {
					route.meta.roles.push(role)
				}
			})

			// Complete children meta
			if (route.children) {
				route.children = this.completeRoutesMeta(route.children, roles, route.meta.layout, this.buildBequeathedMeta(route.meta))
			}
			return route
		})
	},
	buildBequeathedMeta (meta) {
		let metaToBequeath = meta.bequeath === true ? meta : {}
		if (typeof meta.bequeath === Array && meta.bequeath.length > 0) {
			// Inherit only the specified meta attributes in route.meta.bequeath
			metaToBequeath = meta.bequeath.map((prop) => {
				let obj = {}
				obj[prop] = meta[key]
				return obj
			})
		}
		return metaToBequeath
	},
	buildInheritedMeta (meta, inheritedMeta = {}) {
		if (Object.keys(inheritedMeta).length > 0) {
			if (inheritedMeta.i18n && meta.i18n) {
				if (!Array.isArray(inheritedMeta.i18n)) inheritedMeta.i18n = [inheritedMeta.i18n]
				if (!Array.isArray(meta.i18n)) meta.i18n = [meta.i18n]
				meta.i18n = [...inheritedMeta.i18n, ...meta.i18n]
			}
			meta = Object.assign({}, inheritedMeta, meta)
		}
		return meta
	}
}



// WEBPACK FOOTER //
// ./src/router/routeHelpers.js